import { QueryParamProvider } from 'use-query-params';
import { ReactRouter6Adapter } from 'use-query-params/adapters/react-router-6';
import { A11ySettingsProvider } from '@lwtears/lwt-common-frontend/lib/@a11y/A11ySettings/state/A11ySettingsProvider';
import { AlertProvider } from '@lwtears/lwt-common-frontend/lib/Alert';
import { ModalProvider } from '@lwtears/lwt-common-frontend/lib/Modal/providers/ModalProvider';
import { RouteGuardProvider } from '@lwtears/lwt-common-frontend/lib/RouteGuard';
import { AssessmentProvider } from 'state/providers/AssessmentProvider';
import LanguageProvider from './LanguageProvider';

const AppProviders: React.FunctionComponent<React.PropsWithChildren<unknown>> = (props) => {
  return (
    <QueryParamProvider adapter={ReactRouter6Adapter}>
      <A11ySettingsProvider>
        <AlertProvider>
          <AssessmentProvider>
            <ModalProvider>
              <LanguageProvider>
                <RouteGuardProvider>{props.children}</RouteGuardProvider>
              </LanguageProvider>
            </ModalProvider>
          </AssessmentProvider>
        </AlertProvider>
      </A11ySettingsProvider>
    </QueryParamProvider>
  );
};

export default AppProviders;
